export type Event =
  | { type: 'show' }
  | { type: 'hide'; seenOfferIds: string[] }
  | { type: 'reset' };
